import React, { FC, PropsWithChildren } from 'react';
import classes from './styles/backofficeWidget.module.scss';
import { Typography } from '../../../../components/Typography';

export const BackofficeWidgetCardHeading: FC<PropsWithChildren> = ({ children }) => {
	return (
		<div className={classes.backofficeWidget__heading}>
			<Typography
				headingSize={3}
				bold
			>
				{children}
			</Typography>
		</div>
	);
};
